var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"text-h1 text-center mt-n12 black--text",attrs:{"id":"404"}},[_vm._v(" 404 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }